import {useQuery} from "@tanstack/react-query";
import {useAuthStore} from "@/store/useAuth.store";
import {getLotteryGamesService} from "../services/getLotteryGames.service";

const useGetLotteryGames = () => {
  const authStatus = useAuthStore(state => state.authStatus);
  return useQuery({
    queryKey: ["lottery-games", authStatus],
    queryFn: getLotteryGamesService,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: authStatus === "authenticated",
    retry: false,
  });
};

export default useGetLotteryGames;
